"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { User, House as Home, BookOpen, Users, Shield, Calendar, LayoutDashboard, Menu as MenuIcon, Image, Download, ChevronDown } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";
function ZonaPPMenuConsumer({
  activeMenuPath,
  isMobile = false
}: {
  activeMenuPath?: string;
  isMobile?: boolean;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  const processedMenuItems = React.useMemo(() => {
    if (!menuItems) return [];
    return [...menuItems].sort((a, b) => (a.order || 0) - (b.order || 0));
  }, [menuItems]);
  const iconMap: Record<string, React.ReactNode> = {
    "Beranda Zona PP": <Home className="h-6 w-6 lg:h-8 lg:w-8" />,
    "Profil & Sejarah": <BookOpen className="h-6 w-6 lg:h-8 lg:w-8" />,
    "Struktur & Hierarki": <Users className="h-6 w-6 lg:h-8 lg:w-8" />,
    "Badan, Lembaga & Sayap": <Shield className="h-6 w-6 lg:h-8 lg:w-8" />,
    "Tokoh & Senior": <User className="h-6 w-6 lg:h-8 lg:w-8" />,
    "Warta & Agenda": <SafeHydrate><Calendar className="h-6 w-6 lg:h-8 lg:w-8" /></SafeHydrate>,
    "Layanan Organisasi": <LayoutDashboard className="h-6 w-6 lg:h-8 lg:w-8" />,
    "Galeri": <Image className="h-6 w-6 lg:h-8 lg:w-8" />,
    "Download": <Download className="h-6 w-6 lg:h-8 lg:w-8" />
  };
  if (loading) {
    return <div className={cn("flex", isMobile ? "flex-col gap-2" : "gap-4")}>
        {[...Array(7)].map((_, i) => <div key={i} data-index={i} className="h-10 w-full bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  const currentPath = activeMenuPath || (typeof window !== 'undefined' ? window.location.pathname.replace(/\/$/, '') : '');
  return <NavigationMenu viewport={false} className="w-full">
      <NavigationMenuList className={cn("gap-3 md:gap-6 lg:gap-10", isMobile ? "flex-col items-start w-full" : "flex-col items-center")}>
        {processedMenuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i} className={cn(isMobile ? "w-full" : "")}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className={cn("group flex flex-col items-center gap-2 px-3 py-2 text-xs md:text-sm lg:text-base font-medium transition-colors rounded-md", currentPath === (item.href || "").replace(/\/$/, '') ? "bg-white/20 text-white" : "text-white hover:bg-white/10 group-hover:text-yellow-300")}>
                <span>
                  {iconMap[item.label] || <Home className="h-6 w-6 lg:h-8 lg:w-8" />}
                </span>
                <span>{item.label}</span>
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function NewsHero() {
  return <section data-section-id="18148" id="zonapphero" className="relative font-sans bg-gradient-to-r from-red-600/80 via-red-500/70 to-red-600/80">
      <div className="container mx-auto px-4 h-20 flex items-center justify-between text-white shadow-md">
        <div className="flex items-center gap-3">
          <WvcLogo className="h-8 w-auto" />
          <div className="hidden md:block h-6 w-px bg-white/20 mx-2" />
          <span className="hidden md:block font-bold text-lg text-white font-semibold">Zona Pemuda Pancasila</span>
        </div>

        <div className="hidden lg:flex">
          <MenuProvider menu_id="1219">
            <ZonaPPMenuConsumer />
          </MenuProvider>
        </div>

        <div className="lg:hidden">
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="text-white hover:bg-red-700/30">
                <MenuIcon className="size-6" />
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="w-[150px] bg-gradient-to-b from-red-600/80 via-red-500/70 to-red-600/80 border-0">
              <SheetHeader>
                <SheetTitle className="text-white">Menu</SheetTitle>
              </SheetHeader>
              <MenuProvider menu_id="1219">
                <ZonaPPMenuConsumer isMobile />
              </MenuProvider>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </section>;
}